import apiClient from "../../../../../utils/clients/axios";

export const managerFinisherDrawingNotification = async () => {
  const response = await apiClient.get(
    "/api/quality_control/finisher/notifications/"
  );
  return response;
};